import { useTranslation } from 'react-i18next'
import { cx } from '@k1p4/ui'
import type { AppLanguage } from '@k1p4/i18n'
import { api } from '../api/client'
import { useOptionalAuth } from '../auth/AuthProvider'
import { storeLanguage } from '../i18n'
import styles from './LanguageSwitcher.module.css'

const LANGUAGES: readonly AppLanguage[] = ['pl', 'en']

/**
 * Przełącznik PL/EN — wg planu §8.4 obecny na KAŻDEJ stronie
 * (odstępstwo od makiet wymagane przez CLAUDE.md, rejestr §18 D5).
 */
export function LanguageSwitcher({ className }: { className?: string }) {
  const { t, i18n } = useTranslation()
  const current = i18n.resolvedLanguage ?? i18n.language
  const auth = useOptionalAuth()

  function select(lang: AppLanguage): void {
    if (lang === current) return
    void i18n.changeLanguage(lang)
    storeLanguage(lang)
    /*
     * Wybór zalogowanej osoby trafia do konta — po nim idą maile (fala 9,
     * grupa 76). Porażka zapisu nie cofa przełączenia: interfejs zmienia się
     * od razu, a konto nadgoni przy następnym kliknięciu.
     */
    if (auth?.session) {
      void api
        .updateLocale(lang)
        .then(() => auth.refresh())
        .catch(() => undefined)
    }
  }

  return (
    <div className={cx(styles.root, className)} role="group" aria-label={t('shell.langSwitch')}>
      {LANGUAGES.map((lang) => (
        <button
          key={lang}
          type="button"
          className={cx(styles.option, lang === current && styles.active)}
          aria-pressed={lang === current}
          onClick={() => select(lang)}
        >
          {lang}
        </button>
      ))}
    </div>
  )
}
